import { render, staticRenderFns } from "./trainingModel.vue?vue&type=template&id=02bae3de"
import script from "./trainingModel.vue?vue&type=script&lang=js"
export * from "./trainingModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports